type AppToastType = 'success' | 'error' | 'info';

export type AppToastNotification = {
  message: string;
  type: AppToastType;
};

type AppToastProps = {
  notification: AppToastNotification | null;
  visible: boolean;
};

export default function AppToast({ notification, visible }: AppToastProps) {
  if (!notification) return null;

  const toneClass =
    notification.type === 'error'
      ? 'border-red-200 bg-red-50 text-red-700'
      : notification.type === 'info'
      ? 'border-slate-200 bg-slate-50 text-slate-700'
      : 'border-emerald-200 bg-emerald-50 text-emerald-700';

  return (
    <div
      className={`fixed left-1/2 top-6 z-[120] -translate-x-1/2 rounded-lg border px-4 py-2 text-sm font-bold shadow-md transition-all duration-300 ${toneClass} ${
        visible ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0 pointer-events-none'
      }`}
    >
      {notification.message}
    </div>
  );
}
